<app-banner>
    <form [formGroup]="resetForm" class="public-page-forms" (ngSubmit)="onSubmit()">
        <h1 class="form-title text-primary" i18n="@@resendEmail.title">Verificatiemail opnieuw verzenden</h1>
        <div class="input-container">
            <label for="inputEmail" i18n="@@email">E-mailadres</label>
            <input id="inputEmail" type="email" formControlName="email" class="text-input" required autocomplete="email" />
        </div>
        <div
            class="text-success transition-opacity duration-200"
            [ngClass]="success ? 'opacity-100' : 'opacity-0'"
            [class.hidden]="!success"
            i18n="@@resendEmail.successMessage"
        >Verificatiemail opnieuw verzonden. Check je email!</div>
        <div class="button-row">
            <button type="submit" class="button-primary huge w-full" [disabled]="!resetForm.valid || busy">
                <ng-container [ngTemplateOutlet]="!busy ? defaultMessage : loading"></ng-container>
            </button>
        </div>
        <a class="font-bold primary-link" routerLink="/login" i18n="@@public.backToLogin">Terug naar loginpagina</a>
    </form>
</app-banner>

<ng-template #defaultMessage><span i18n="@@resendEmail.actionMessage">Verzend verificatiemail</span></ng-template>
<ng-template #loading> <fa-icon class="mr-0" [icon]="loadingIcon" [animation]="'spin'"></fa-icon></ng-template>
